$(function () {
    var $body = $('body');

    $('[data-menu-sidebar-toggle]').each(function () {
        var $el = $(this);
        $el.click(function (e) {
            e.stopPropagation();
            e.preventDefault();
            if (localStorage.getItem('menu-sidebar') === 'close') {
                localStorage.setItem('menu-sidebar', 'open');
            } else {
                localStorage.setItem('menu-sidebar', 'close');
            }
            update();
        });
    });

    function update() {
        $body.addClass('menu-sidebar--animating');
        if (localStorage.getItem('menu-sidebar') === 'close') {
            $body.removeClass('menu-sidebar--is-open');
        } else {
            $body.addClass('menu-sidebar--is-open');
        }
        setTimeout(function () {
            $body.removeClass('menu-sidebar--animating');
        }, 300);
    }

    function closeAll() {
        localStorage.setItem('menu-sidebar', 'close');
        update();
    }
    
    setTimeout(function () {
        $body.addClass('menu-sidebar--can-animate');
    }, 300);

    $('html, body').click(function () {
        if (window.matchMedia("(max-width: 768px)").matches) {
            closeAll();
        }
    });

    window.addEventListener("orientationchange", function () {
        if (screen.orientation.angle === 0) {
            closeAll();
        }
    });
});